module.exports = __webpack_public_path__ + "static/media/netbeans.2de48ee0.png";